export const build = Symbol('build');
export const validateAndBuild = Symbol('validateAndBuild');
export const validate = Symbol('validate');
export const validated = Symbol('validated');